import {useBuChapterStore} from '@/stores/dictionary/budgetChapterStore';
import {useBuChapterGradeStore} from '@/stores/dictionary/budgetChapterGradeStore';
import {useAccountStore} from '@/stores/dictionary/accountStore';
import {useAccountTransferStore} from '@/stores/dictionary/accountTransferStore';
import {useBankInfoStore} from '@/stores/dictionary/bankInfoStore.js';
import {useDefaultAccountStore} from '@/stores/dictionary/defaultAccountStore';
import {useBankInfoCategoryStore} from '@/stores/dictionary/bankInfoCategoryStore';
import {useFundStore} from '@/stores/dictionary/fundStore.js';
import {useBudgetKindItemStore} from '@/stores/dictionary/budgetKindItemStore';
import {useBudgetItemStore} from '@/stores/dictionary/budgetItemStore.js';
import {useBudgetSourcePropertyStore} from '@/stores/dictionary/budgetSourcePropertyStore';
import {useBudgetProvideStore} from '@/stores/dictionary/budgetProvideStore';
import {useBudgetDistributionStore} from '@/stores/dictionary/budgetDistributionStore';
import {useBudgetGroupItemStore} from '@/stores/dictionary/budgetGroupItemStore';
import {useBudgetItemDetailStore} from '@/stores/dictionary/budgetItemDetailStore';
import {useAccountingObjectCategoryStore} from '@/stores/dictionary/accountingObjectCategoryStore';
import {useAccountingObjectStore} from '@/stores/dictionary/accountingObjectStore';
import {useDepartmentStore} from '@/stores/dictionary/departmentStore.js';
import {useBudgetSourceStore} from '@/stores/dictionary/budgetSourceStore';
import {useProjectStore} from '@/stores/dictionary/projectStore.js';
import {useActivityStore} from '@/stores/dictionary/activityStore.js';
import {useBranchStore} from '@/stores/dictionary/branchStore.js';
import {useActivityCategoryStore} from '@/stores/dictionary/activityCategotyStore';
import {useHamletStore} from '@/stores/dictionary/hamletStore';
import {useLocalBudgetItemStore} from '@/stores/dictionary/localBudgetItemStore';
import {useFundStructureStore} from '@/stores/dictionary/fundStructureStore';
import {useStatisticStore} from '@/stores/dictionary/statisticStore';
import {useSalaryScaleStore} from '@/stores/dictionary/salaryScaleStore';
import {useFixedAssetCategory} from '@/stores/dictionary/fixedAssetCategoryStore';
import {useInventoryCategoryStore} from '@/stores/dictionary/stock/inventoryCategoryStore';
import {useEquipmentInventoryItemStore} from '@/stores/dictionary/stock/equipmentInventoryItemStore.js';
import {useStockStore} from '@/stores/dictionary/stock/stockStore.js'; // khoản
import {useFixedAssetStore} from '@/stores/dictionary/fixedAssetStore';
import {useFrFunctionListStore} from '@/stores/fr/frFunctionListStore';
import {useAutoBusinessStore} from '@/stores/dictionary/autoBusinessStore';
import {useContractStore} from '@/stores/dictionary/contractStore';
import {useFilterHistoryStore} from '../filters/filterHistoryStore';
import {useDvcBudgetStore} from '@/stores/dictionary/dvcBudgetStore';
import {useCommercialBankStore} from '@/stores/dictionary/commercialBankStore.js';
import {useDashboardParamStore} from '../dashboard/dashboardParamStore';
import {useDashboardDataStore} from '../dashboard/dashboardDataStore';
import {useBudgetSourceDvcStore} from '@/stores/dictionary/budgetSourceDvcStore.js';
import {useAriseVoucherInformationStore} from '@/stores/dictionary/ariseVoucherInformationStore.js';
import {useSupplierInvoiceBotStore} from '@/stores/supplierInvoiceBot/supplierInvoiceBotStore';
import {useDbOptionStore} from '@/stores/dbOptionStore';

import {
  ModuleBudgetChapter,
  ModuleBudgetChapterGrade,
  ModuleAccount,
  ModuleAccountTransfer,
  ModuleBankInfo,
  ModuleDefaultAccount,
  ModuleBankInfoCategory,
  ModuleFund,
  ModuleBudgetKindItem,
  ModuleBudgetItem,
  ModuleBudgetSourceProperty,
  ModuleBudgetProvide,
  ModuleBudgetGroupItem,
  ModuleAccountingObjectCategory,
  ModuleAccountingObjectList,
  ModuleAccountingObject,
  ModuleDepartment,
  ModuleBudgetSource,
  ModuleProject,
  ModuleActivityCategory,
  ModuleActivity,
  ModuleBranch,
  ModuleHamlet,
  ModuleInventoryCategory,
  ModuleLocalBudgetItem,
  ModuleFundStructure,
  ModuleStatistic,
  ModuleBudgetItemDetail,
  ModuleSalaryScale,
  ModuleFixedAssetCategory,
  ModuleFixedAsset,
  ModuleInventoryItem,
  ModuleEquipmentInventoryItem,
  ModuleStock,
  ModuleBudgetDistribution,
  ModuleFunctionList,
  ModuleAutoBusiness,
  ModuleContract,
  ModuleFilterHistory,
  ModuleDvcBudget,
  ModuleCommercialBank,
  ModuleBudgetSourceDvc,
  ModuleDashboardData,
  ModuleDashboardParam,
  ModuleVoucherInformationArise,
  ModuleDIFixedAsset, // Danh mục tài sản cố định (nvthinh 26.06.2024)
  ModuleSupplierInvoiceBot,
  ModuleDbOption,
} from '@/stores/moduleConst';

export const useWebSocketFactoryCacheStore = () => {
  /**
   * Lấy store theo từng nghiệp vụ
   * HQMINH 14.04.2023
   * @param {*} module
   * @returns
   */
  const factoryCacheStore = module => {
    switch (module) {
      case ModuleBudgetChapter:
        return useBuChapterStore();
      case ModuleBudgetChapterGrade:
        return useBuChapterGradeStore();
      case ModuleAccount:
        return useAccountStore();
      case ModuleAccountTransfer:
        return useAccountTransferStore();
      case ModuleBankInfo:
        return useBankInfoStore();
      case ModuleDefaultAccount:
        return useDefaultAccountStore();
      case ModuleBankInfoCategory:
        return useBankInfoCategoryStore();
      case ModuleFund:
        return useFundStore();
      case ModuleBudgetKindItem:
        return useBudgetKindItemStore();
      case ModuleBudgetItem:
        return useBudgetItemStore();
      case ModuleBudgetSourceProperty:
        return useBudgetSourcePropertyStore();
      case ModuleBudgetProvide:
        return useBudgetProvideStore();
      case ModuleBudgetGroupItem:
        return useBudgetGroupItemStore();
      case ModuleBudgetItemDetail:
        return useBudgetItemDetailStore();
      case ModuleActivityCategory:
        return useActivityCategoryStore();
      case ModuleActivity:
        return useActivityStore();
      case ModuleBranch:
        return useBranchStore();
      case ModuleAccountingObjectCategory:
        return useAccountingObjectCategoryStore();
      case ModuleAccountingObjectList:
        return useAccountingObjectStore();
      case ModuleAccountingObject:
        return useAccountingObjectStore();
      case ModuleDepartment:
        return useDepartmentStore();
      case ModuleBudgetSource:
        return useBudgetSourceStore();
      case ModuleProject:
        return useProjectStore();
      case ModuleHamlet:
        return useHamletStore();
      case ModuleLocalBudgetItem:
        return useLocalBudgetItemStore();
      case ModuleFundStructure:
        return useFundStructureStore();
      case ModuleStatistic:
        return useStatisticStore();
      case ModuleSalaryScale:
        return useSalaryScaleStore();
      case ModuleFixedAssetCategory:
        return useFixedAssetCategory();
      case ModuleFixedAsset:
        return useFixedAssetStore();
      case ModuleInventoryCategory:
        return useInventoryCategoryStore();
      case ModuleInventoryItem:
      case ModuleEquipmentInventoryItem:
        return useEquipmentInventoryItemStore();
      case ModuleStock:
        return useStockStore();
      case ModuleBudgetDistribution:
        return useBudgetDistributionStore();
      case ModuleFunctionList:
        return useFrFunctionListStore();
      case ModuleAutoBusiness:
        return useAutoBusinessStore();
      case ModuleContract:
        return useContractStore();
      case ModuleFilterHistory:
        return useFilterHistoryStore();
      case ModuleDvcBudget:
        return useDvcBudgetStore();
      case ModuleCommercialBank:
        return useCommercialBankStore();
      case ModuleDashboardData:
        return useDashboardDataStore();
      case ModuleDashboardParam:
        return useDashboardParamStore();
      case ModuleBudgetSourceDvc:
        return useBudgetSourceDvcStore();
      case ModuleVoucherInformationArise:
        return useAriseVoucherInformationStore();
      // Danh mục tài sản cố định (nvthinh 26.06.2024)
      case ModuleDIFixedAsset:
        return useFixedAssetStore();
      case ModuleSupplierInvoiceBot:
        return useSupplierInvoiceBotStore();
      case ModuleDbOption:
        return useDbOptionStore();
      default:
        break;
    }
  };

  return {
    factoryCacheStore,
  };
};
